<template>
    <div class="erm_form_wrapper">

        <div class="input-wrapper">
            <p class="form-label" for="name">Table Number *</p>
            <el-input class="erm_input" v-model="tables.table_number " style="width: 100%"
                placeholder="Please Input Name" size="large" />
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ table_number_error }}</p>
        </div>
     

        <div class="input-wrapper">
            <p class="form-label" for="name"> Table Capacity *</p>
            <el-input class="erm_input" v-model="tables.capacity" style="width: 100%"
                placeholder="Please Input table capacity" size="large" type="number" />
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ capacity_error }}</p>
        </div>

        <!-- <div class="input-wrapper">
            <p class="form-label" for="name">Branch *</p>
            <el-select class="erm_input"  v-model="tables.branch_id" placeholder="Input status " size="large"
                style="width: 100%;  margin-bottom: 20px;">
                <el-option selected value="1" />
            </el-select>
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ branch_id_error }}</p>
        </div> -->

        <div class="input-wrapper">
            <p class="form-label" for="name">Status *</p>
            <el-select class="erm_input" v-model="tables.status" placeholder="Input status " size="large"
                style="width: 100%;  margin-bottom: 20px;">
                <el-option value="available" />
                <el-option value="reserved" />
                <el-option value="occupied" />
            </el-select>
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ status_error }}</p>
        </div>


        <div class="input-wrapper" @click="saveTableData()">
            <el-button size="large" type="primary">Save Table</el-button>
        </div>

    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            tables: {
                table_number : "",
                capacity: "",
                status: "",
                branch_id: "1",
            },
            table_number_error: "",
            capacity_error: "",
            status_error: "",
            branch_id_error: "",
            rest_api: window.RestaurantMenuMangeData.rest_api,
        };
    },
    props: {
        tables_data: {
            type: Object,
        }
    },
    watch: {
        tables_data: {
            handler: function (val) {
                this.tables = val;
            },
            deep: true
        }
    },

    methods: {
        async saveTableData() {
            this.table_number_error = "";
            this.capacity_error = "";
            this.status_error = "";
            this.branch_id_error = "";
            if (!this.tables.table_number) {
                this.table_number_error = "Table number is required";
                return;
            }
            if (!this.tables.capacity) {
                this.capacity_error = "Table capacity is required";
                return;
            }
            if (!this.tables.status) {
                this.status_error = "Table status is required";
                return;
            }
            if (!this.tables.branch_id) {
                this.branch_id_error = "Brunch name is required";
                return;
            }
          
            try {
                const response = await axios.post(`${this.rest_api}/postTable`, {
                    data: this.tables,
                    table_number: this.tables.table_number,
                    capacity: this.tables.capacity ,
                    status: this.tables.status,
                    branch_id: this.tables.branch_id,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'easyRestaurantManager-nonce': window.RestaurantMenuMangeData.nonce,
                    }
                });
                console.log('Tables Data:', response.data);
                this.$emit("updateDataAfterNewAdd", this.tables);
                this.tables = { table_number: "", branch_id: "", capacity: "", status: "" };
            } catch (error) {
                console.error('Error fetching table:', error);
            }
        },


    },
    mounted() {
        if (this.tables_data) {
            console.log('Tables:', this.tables_data);
            this.tables = this.tables_data;
        }
    }

};
</script>